export default "__VITE_ASSET__Dn9c$x1U__"